import type { VoidFunctionComponent } from 'react';
import styles from './ProjectGroupPortalSettings.module.less';
import { RouterLink } from '../../../../generic';
import SettingsPageHeader from '../../../../shared/settings/SettingsPageHeader';

type BaseProps = {
  portalUrl?: string | null;
};

/**
 * Renders either a Router link to the portal (if the URL exists), or just the text 'portal'.
 */
const PortalSettingsHeaderLink: VoidFunctionComponent<BaseProps> = ({ portalUrl }) => {
  return portalUrl ? (
    <RouterLink to={portalUrl} openInNewTab>
      portal
    </RouterLink>
  ) : <>portal</>;
};

/**
 * PortalSettingsHeaderInline is the style of header used when
 * the PortalSettings are embedded in a page.
 */
export const PortalSettingsHeaderInline: VoidFunctionComponent<BaseProps> = ({ portalUrl }) => (
  <div className={styles.header}>
    <div className={styles.title}>Portal Settings</div>
    <div className={styles.description}>
      Control access to SBOMs published to your
      {' '}
      <PortalSettingsHeaderLink portalUrl={portalUrl} />
      .
    </div>
  </div>
);

type PortalSettingsHeaderFullPageProps = BaseProps & {
  isDirty: boolean;
  onSave: () => Promise<void>;
};

/**
 * PortalSettingsHeaderSettingsPage is the style of header used when
 * the PortalSettings are displayed on a full page.
 */
export const PortalSettingsHeaderFullPage: VoidFunctionComponent<PortalSettingsHeaderFullPageProps> = ({
  portalUrl,
  isDirty,
  onSave,
}) => (
  <SettingsPageHeader heading="Portal Settings">
    <SettingsPageHeader.SaveButton
      isDisabled={!isDirty}
      onClick={onSave}
    />
    <SettingsPageHeader.Paragraph>
      Control access to SBOMs published to your
      {' '}
      <PortalSettingsHeaderLink portalUrl={portalUrl} />
      .
    </SettingsPageHeader.Paragraph>
  </SettingsPageHeader>
);
